module.exports = __webpack_public_path__ + "static/langojango-italian-language-phrasebook-5a2a326ee26885371747369fddb54558.png";